import { WishAndExpectation, wishesForPage1, wishesForPage2, wishesForPage3, preparations } from '../../../ana-toolbox'

export const filterRequired = (wish: WishAndExpectation, values: WishAndExpectation[] | undefined): boolean => {
  if (wish.requireTrue) {
    return !!values?.find((w) => w.key === wish.requireTrue)?.flag
  }

  if (wish.requireFalse) {
    return !values?.find((w) => w.key === wish.requireFalse)?.flag
  }

  return true
}

export const wishesAndExpectations: WishAndExpectation[] = [
  ...wishesForPage1,
  ...wishesForPage2,
  ...wishesForPage3,
  ...preparations,
]
